import React, { useState, useRef } from 'react';
import { useField } from 'formik';

import { numToLetter } from '~/commons/helpers';
import useEventListener from '~/commons/hooks/useEventListener';

const colors = [
  '#59BCCB',
  '#D700FF', //'#F4F438',
  '#FFA02E',
  '#36AD37',
  '#E54C75',
  '#344DE2',
  '#ED784F',
  '#9E8AFF',
  '#9ECFA1',
  '#FF80FF',
];

const getColor = ({ matching, index }) => {
  if (matching) {
    return {
      color: '#212529',
      border: 'solid 3px #212529',
    };
  }

  if (index !== undefined) {
    return {
      color: colors[index],
      border: `solid 3px ${colors[index]}`,
    };
  }

  return {
    color: '#bbb',
    border: 'solid 3px #eee',
  };
};

const FieldsMatching = ({
  qtnIndex: i,
  question: q,
  isCorrect,
  correctAns: cAns,
  disabled = false,
}) => {
  const fieldRef = useRef();
  const [, { value }, { setValue }] = useField(`answers.${i}.answeredSeq`);
  const [values, setValues] = useState([]);
  const [matching, setMatching] = useState(null);
  let vv = [...value];
  let vs = [...values];

  const match = (type, index, rIndex) => {
    if (!disabled) {
      if (matching && matching.type !== type) {
        let slot; let ans;

        if (type === 'clues') {
          slot = matching.index;
          ans = index;
        } else {
          slot = index;
          ans = matching.index;
        }

        // remove duplicates
        vv = vv.map((v) => (v === ans ? undefined : v));

        // set value
        vv[slot] = ans;

        setValue(vv);
        setMatching(null);

        let rSlot; let rAns;
        if (type === 'clues') {
          rSlot = matching.rIndex;
          rAns = rIndex;
        } else {
          rSlot = rIndex;
          rAns = matching.rIndex;
        }
        vs = vs.map((v) => (v === rAns ? undefined : v));
        vs[rSlot] = rAns;
        setValues(vs);
        console.log('vs', vs)

      } else {
        setMatching({ type, index, rIndex });
      }
    }
  };

  // defocus when clicking outside
  useEventListener(document, 'click', (e) => {
    if (!fieldRef.current.contains(e.target)) {
      setMatching(null);
    }
  }, [fieldRef.current]);

  return (
    <div className="mt-2">
      {/* answer */}
      <div ref={fieldRef}>
        {q.choices.map(({c, ii},jj) => (
          <div key={ii} className="mb-2">
            <div className="form-row">
              {/* clues */}
              <div className="col">
                <div
                  onClick={() => match('clues', ii, jj)}
                  className={`
                    row m-0
                    h-100 rounded-lg cursor-pointer
                  `}
                  style={getColor({
                    matching: matching?.type === 'clues'
                      && matching.index === ii,
                    index: vv.find((v) => parseInt(v, 10) === ii) !== undefined
                      ? ii : undefined,
                  })}
                >
                  <div className="col-auto p-1">
                    {`(${Number(jj)+1})`}.
                  </div>
                  <div className="col p-1">
                    {c}
                  </div>
                </div>
              </div>
              {/* matches */}
              <div className="col">
                <div
                  onClick={() => match('matches', ii, jj)}
                  className={`
                    row m-0
                    h-100 rounded-lg cursor-pointer
                  `}
                  style={getColor({
                    matching: matching?.type === 'matches'
                      && matching.index === ii,
                    index: vv[ii],
                  })}
                >
                  <div className="col-auto p-1">
                    {numToLetter(jj, true)}.
                  </div>
                  <div className="col p-1">
                    {q.matches[ii]}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      {/* answered */}
      {value && !value.includes(undefined) && (
        <div className={`
          mt-3 py-2 px-4 position-relative
          ${
            cAns !== undefined && !isCorrect
              ? 'bg-light' : 'bg-quinary'
          }
        `}>
          我的答案:
          &nbsp;
          {values
            .map((a, k) => (
              a === undefined
                ? ''
                : `[(${(Number(a)+1)}),${numToLetter(k, true)}]`
            ))
            .sort()
            .join(' ')
          }
          {/* correct/incorrect mark */}
          {cAns !== undefined && (
            <img
              className="pos-abs-br mr-3 mb-2"
              {...isCorrect ? {
                src: '/assets/img/correct.svg',
                style: { width: '42px', height: '36px' },
              } : {
                src: '/assets/img/incorrect.svg',
                style: { width: '34px', height: '40px' },
              }}
            />
          )}
        </div>
      )}
      {/* correct answer */}
      {(cAns !== undefined && !isCorrect) && (
        <div className="text-tertiary mt-3 py-2 px-4">
          正確答案:
          &nbsp;
          {cAns
            .map((a, k) => (
              a === undefined
                ? ''
                : `[(${Number(a)+1}),${numToLetter(q.choices.indexOf(q.choices.find(({ii})=>(ii==k))), true)}]`
            ))
            .sort()
            .join(' ')
          }
        </div>
      )}
    </div>
  );
};

export default FieldsMatching;
